"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenApiResponseOrReferenceDict = void 0;
const dictionary_1 = require("../../dictionary");
const reference_1 = require("../reference");
const response_1 = require("../response");
class OpenApiResponseOrReferenceDict extends dictionary_1.Dictionary {
    constructor(...parts) {
        super([
            (0, dictionary_1.createDictValueCtr)(reference_1.OpenApiReference, reference_1.OpenApiReference.isOpenApiReference),
            (0, dictionary_1.createDictValueCtr)(response_1.OpenApiResponse, [
                response_1.OpenApiResponse.isOpenApiResponse,
                (0, dictionary_1.not)(reference_1.OpenApiReference.isOpenApiReference),
            ]),
        ], ...parts);
    }
}
exports.OpenApiResponseOrReferenceDict = OpenApiResponseOrReferenceDict;
